import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { InlineCatalog } from "@/components/InlineCatalog";
import { PageHeader, Panel, GoldButton, inputCls } from "@/components/common";

export default function Loyalty() {
  const [req, setReq] = useState("");
  useEffect(() => { api.get("/settings/loyalty").then((r) => setReq(r.data.stamps_required)); }, []);
  const save = async () => {
    try { await api.put("/settings/loyalty", { stamps_required: Number(req) }); toast.success("Impostazione salvata"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="loyalty-page">
      <PageHeader overline="Fidelizzazione" title="Tessera fedeltà" />
      <div className="grid gap-6 lg:grid-cols-3">
        <Panel className="p-6">
          <h3 className="font-serif text-2xl mb-2">Regola dei timbri</h3>
          <p className="text-sm text-[#6E675F] mb-5">Ogni appuntamento completato aggiunge un timbro. Puoi anche aggiungerli o toglierli a mano dalla scheda cliente. Raggiunto il numero di timbri, scegli tu lo sconto da dare.</p>
          <label className="text-xs uppercase tracking-[0.14em] text-[#6E675F]">Timbri per ottenere uno sconto</label>
          <div className="mt-2 flex gap-2">
            <input type="number" min="1" max="100" className={`${inputCls} w-24`} value={req} onChange={(e) => setReq(e.target.value)} data-testid="stamps-required-input" />
            <GoldButton onClick={save} data-testid="stamps-required-save">Salva</GoldButton>
          </div>
        </Panel>
        <div className="lg:col-span-2">
          <h3 className="font-serif text-2xl mb-3">Sconti disponibili</h3>
          <InlineCatalog resource="loyalty_rewards" testPrefix="reward" blank={{ name: "", description: "" }} emptyText="Nessuno sconto. Aggiungi il primo qui sotto (es. 10% sul prossimo trattamento)."
            fields={[{ key: "name", label: "Sconto" }, { key: "description", label: "Dettagli / condizioni" }]} />
        </div>
      </div>
    </div>
  );
}
